/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {Languages} from './Languages'
import {toAbsoluteUrl} from '../../../helpers'
import {useTranslation} from 'react-i18next'
import {reset} from '../../../../redux/system/user/userSlice'
import {useAppDispatch} from '../../../../redux/hooks'
import {StopImpersonate} from '../../../../redux/system/user/userSlice'
import {getUserByToken} from 'app/modules/auth/core/_requests'
import {showMessage} from '_metronic/helpers/swalHelper'

const HeaderUserMenu: FC = () => {
  const {t} = useTranslation()
  const dispatch = useAppDispatch()
  const [userId, setUserId] = useState('')
  const {currentUser, logout, saveAuth, setCurrentUser} = useAuth()

  useEffect(() => {
    const storedUserId = localStorage.getItem('impersonator_id')
    if (storedUserId && storedUserId !== '') {
      setUserId(storedUserId) // Set the userId state if it exists
    }
  }, [])

  const handleStopImpersonate = async () => {
    const formData = new FormData()
    formData.append('user_id', userId)
    const res = await dispatch(StopImpersonate(formData))
    if (res.meta.requestStatus === 'fulfilled') {
      saveAuth(res.payload)
      const {data: user} = await getUserByToken(res.payload.api_token)
      setCurrentUser(user)
      localStorage.removeItem('impersonator_id')
      const sys = localStorage.getItem('system')
      if (sys === 'System') window.location.href = '/system-mgt/home'
      else if (sys === 'University') window.location.href = '/dua/home'
      else if (sys === 'School') window.location.href = '/dphs/home'
      else if (sys === 'Canteen') window.location.href = '/canteen/home'
      else window.location.href = `/dashboard`
    } else {
      showMessage(t('MESSAGES.SERVER_ERROR'), 'error')
    }
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={toAbsoluteUrl('/media/avatars/photo.jpg')} />
          </div>

          <div className='d-flex flex-column px-2'>
            <span
              className='badge badge-light-success fw-bolder fs-8 px-2 py-1'
              style={{display: 'inline'}}
            >
              {currentUser?.roles?.length && currentUser.roles.length > 1
                ? `${currentUser.roles.join(' | ')}`
                : currentUser?.roles}
            </span>
            <div className='fw-bolder d-flex align-items-center fs-5 '>{currentUser?.username}</div>
          </div>
        </div>
        <div className='d-flex justify-content-center'>
          <a
            href='#'
            className='fw-bold text-dark text-center fs-7 '
            style={{pointerEvents: 'none', cursor: 'default'}}
          >
            {currentUser?.email}
          </a>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to={'/profile'} className='menu-link px-5' onClick={() => dispatch(reset())}>
          <span className='fa fa-user px-1'></span>
          {t('GLOBAL.MY_ACCOUNT')}
        </Link>
      </div>

      <Languages />

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5 text-danger'>
          <span className='fa fa-power-off px-1'></span>
          {t('GLOBAL.SIGN_OUT')}
        </a>
      </div>

      {userId && (
        <div className='menu-item px-5'>
          <a onClick={() => handleStopImpersonate()} className='menu-link px-5 text-danger'>
            <span className='fa fa-sign-out px-1'></span>
            {t('GLOBAL.LEAVE')}
          </a>
        </div>
      )}
    </div>
  )
}

export {HeaderUserMenu}
